import { Injectable, PLATFORM_ID, Inject, Injector } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApplicationInsightsService {
  private routerSubscription: Subscription;

  private appInsights;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.appInsights = new ApplicationInsights({
        config: {
          instrumentationKey: environment.azureInsightsKey
        }
      });

      this.appInsights.loadAppInsights();
      this.logPageView(location.pathname);

      this.routerSubscription = this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
        const activatedComponent = this.getActivatedComponent(event.state.root);
        if (activatedComponent) {
          this.logPageView(event.url);
        }
      });
    }
  }

  logPageView(uri?: string) {
    this.appInsights.trackPageView({ uri });
  }

  trackException(error: any) {
    if (error instanceof Error) {
      this.appInsights.trackException({
         exception: error
       });
     } else {
      this.appInsights.trackException({
         exception: new Error(error)
       });
     }
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }
}
